import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import FTModal from "../../../components/common/FTModal";
import { AdminFormFieldInput, AdminFormFieldSubmit } from "../../../components/admin/formFields";

type ModalCreateCustomReportProps = {
    handleCreateCustomReport: (reportName:string) => void;
  };

const ModalMakeCustomReport = ({
    handleCreateCustomReport
  }: ModalCreateCustomReportProps) => {
    const { t: tMain } = useTranslation();
    const { t } = useTranslation("translation", {
      keyPrefix: "reports.copyReport",
    });
    const dispatch = useDispatch();

    const modalsState: TModalsState = useSelector(
      (state: any) => state.commonReducer.modals
    );
  
    const hideModal = () => {
      dispatch(setModalsData({ ...modalsState, showModalMakeCustomReport: false }));
    };
  
    const formik = useFormik({
      initialValues: { report_name: "" },
      validationSchema: Yup.object({
        report_name: Yup.string().required("Report name is required"),
      }),
      onSubmit: (values) => {  
        handleCreateCustomReport(values.report_name); 
        hideModal();    
      },
    });
  

    return (
      <FTModal
        visible={modalsState.showModalMakeCustomReport}
        dismissible={true}
        heading={t("rename_report")}
        onHide={hideModal}
        containerStyle="max-w-[calc(100vw-4rem)] w-[450px]"
        position="center"
        positionHorizontal="center"
      >
              <>
                <form onSubmit={formik.handleSubmit} className="mt-6">
                  <AdminFormFieldInput
                    label={t("report_name")}
                    type="text"
                    id="report_name"
                    name="report_name"
                    placeholder="Enter Report Name"
                    value={formik.values.report_name}
                    onChange={formik.handleChange}
                  />
                  <AdminFormFieldSubmit
                    customWrapperClass="mt-6"
                    label={tMain("confirm")}
                    variant="primary"
                    type="submit"
                    disabled={!formik.isValid || !formik.values.report_name}
                  />
  
                  <AdminFormFieldSubmit
                    customWrapperClass="mt-6"
                    variant="danger-transparent"
                    type="button"
                    label={tMain("cancel")}
                    onClick={hideModal}
                  />
                </form>
              </>
      </FTModal>
    )}
  export default ModalMakeCustomReport;